import { render, staticRenderFns } from "./LayoutInsightsHeader.vue?vue&type=template&id=2506b56b&scoped=true&"
import script from "./LayoutInsightsHeader.vue?vue&type=script&lang=js&"
export * from "./LayoutInsightsHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayoutInsightsHeader.vue?vue&type=style&index=0&id=2506b56b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2506b56b",
  null
  
)

export default component.exports